import React from 'react';
import { View, Text as PDFText, StyleSheet, Font } from '@react-pdf/renderer';
import MontserratRegular from './fonts/Montserrat-Regular.ttf';

Font.register({
    family: 'MontserratRegular',
    fonts: [
        { src: MontserratRegular, fontWeight: 400 },
    ]
});
const blue = "#003952"

// Custom Text component that always includes font family
const Text = (props) => (
    <PDFText {...props} style={{ fontFamily: 'MontserratRegular', ...props.style }} />
);

// Simple styles without complex nesting
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#E0E0E0',
        borderBottomStyle: 'solid',
        alignItems: 'flex-start',
        minHeight: 25,
        width: '100%'
    },
    cell: {
        padding: '5pt',
        fontSize: 8,
        fontFamily: 'monts',
        fontWeight: 400,
        color: '#333333',
    },
    headerRow: {
        backgroundColor: blue,
    },
    headerCell: {
        color: '#ffffff',
        fontFamily: 'monts',
        fontWeight: 700,
        fontSize: 8,
    },
    commentRow: {
        backgroundColor: '#F5F5F5',
        minHeight: 20,
    },
    commentCell: {
        fontSize: 9,
        paddingTop: 6,
        paddingBottom: 6,
        fontFamily: 'monts',
        paddingLeft: 15,
        borderLeftWidth: 2,
        borderLeftColor: '#CCCCCC',
        borderLeftStyle: 'solid',
        fontWeight: 500
    },
    commentCell: {
        fontSize: 7,
        color: '#555555',
        paddingLeft: 5,
    },
    textRight: {
        textAlign: 'right',
        fontFamily: 'monts',
        fontWeight: 400
    },
    reductionRow: {
        backgroundColor: '#F5F5F5',
        fontStyle: 'italic',
    },
    cellDescriptionStyle: {
        fontSize: 7,
        marginTop: 5,
        fontWeight: 500,
        color: '#888888',
        padding: '3pt 5pt'
    }
});

// Simplified TableRow with explicit style objects for each case
const TableRow = ({ data = [], widths = [], isHeader, tableStyle = '' }) => {
    let rowStyle = styles.row;

    if (isHeader) rowStyle = { ...rowStyle, ...styles.headerRow };
    if (tableStyle === 'comment') rowStyle = { ...rowStyle, ...styles.commentRow };
    if (tableStyle === 'subheader') rowStyle = { ...rowStyle, ...styles.subheaderRow };
    if (tableStyle === 'reduction') rowStyle = { ...rowStyle, ...styles.reductionRow };

    return (
        <View style={rowStyle} wrap={false}>
            {data.map((cellData, index) => {
                let cellStyle = { ...styles.cell };
                let DescriptionCellStyle = { ...styles.cellDescriptionStyle };

                if (isHeader) cellStyle = { ...cellStyle, ...styles.headerCell };
                if (index >= 1) cellStyle = { ...cellStyle, ...styles.textRight };

                if (typeof cellData === 'object' && cellData !== null) {
                    return (
                        <View
                            key={index}
                            style={{
                                width: widths[index] || 'auto',
                                flex: widths[index] ? undefined : 1
                            }}
                        >
                            <Text style={cellStyle}>{cellData.displayLabel}</Text>
                            {cellData.description ? (
                                <Text style={DescriptionCellStyle}>{cellData.description}</Text>
                            ) : null}
                        </View>
                    );
                }

                const content =
                    typeof cellData === 'number'
                        ? index >= 2
                            ? cellData.toFixed(2)
                            : cellData.toString()
                        : String(cellData || '');

                return (
                    <View
                        key={index}
                        style={{
                            width: widths[index] || 'auto',
                            flex: widths[index] ? undefined : 1
                        }}
                    >
                        <Text style={cellStyle}>{content}</Text>
                    </View>
                );
            })}
        </View>
    );
};

export default TableRow;
